import type { MailJobDefinition, MailJobSummary } from '@rb/shared/mail/job.types';
import { readAuthToken } from '@/auth/auth-token';

function normalizeBaseUrl(baseUrl: string): string {
  if (!baseUrl) throw new Error('메일 워커 URL 없음 — verse(env)에 배포된 워커가 없습니다');
  return baseUrl.replace(/\/$/, '');
}

async function post<T>(baseUrl: string, path: string, body: unknown): Promise<T> {
  const token = readAuthToken();
  if (!token) throw new Error('로그인 토큰 없음');
  const res = await fetch(`${normalizeBaseUrl(baseUrl)}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const json = (await res.json().catch(() => ({}))) as { ok?: boolean; error?: string } & Record<
    string,
    unknown
  >;
  if (!res.ok || json.ok === false) throw new Error(json.error || `HTTP ${res.status}`);
  const { ok, error, ...data } = json;
  return data as T;
}

export function previewMail(
  baseUrl: string,
  def: MailJobDefinition
): Promise<{ previewId: string; summary: MailJobSummary }> {
  return post(baseUrl, '/preview', def);
}

export function confirmMail(
  baseUrl: string,
  previewId: string
): Promise<{ jobId: string; enqueued: number }> {
  return post(baseUrl, '/confirm', { previewId });
}
